import { render, staticRenderFns } from "./RegisterSupplier.vue?vue&type=template&id=4aa117d7&scoped=true&"
import script from "./RegisterSupplier.vue?vue&type=script&lang=js&"
export * from "./RegisterSupplier.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSupplier.vue?vue&type=style&index=0&id=4aa117d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa117d7",
  null
  
)

export default component.exports